/**
 * The operator session's query key, on its own so the app-wide MFA guard can
 * name it without pulling the platform console into the initial download.
 */
export const PLATFORM_SESSION_KEY = ['platform', 'session'] as const;
